import { MapPinIcon } from '@heroicons/react/20/solid';

interface TGPSInputProps {
  openModal: () => void;
  label: string;
}
/**
 * -----------------------------------------------------------------------------
 * This is used to capture the location of a person or organization.
 */
export function GPSInputField({ openModal, label }: TGPSInputProps) {
  return (
    <button
      className="form-input-field inline-flex justify-between text-sm
        font-light text-gray-600"
      onClick={openModal}
      type="button"
    >
      {label}
      <MapPinIcon className="h-6 w-6" />
    </button>
  );
}
